import { getVoyageNumber } from "../../../utils/domainSelectors";
import { getSelectedCargo, getSelectedTrip } from "../../../utils/voyageSelection";

export const createDeadweightPrintViewModelV2 = ({
  currentVoyage,
  selectedTripId,
  selectedCargoIndex,
  companyLogo,
  zone,
  governingDWT,
  bunkerConsumption,
  bunkers,
  freshwater,
  stores,
  ballast,
  slops,
  availableCBM,
  density,
  maxQuantAccCP,
  claim,
  claimedDeadweight,
  requestedCargoMT,
  requestedCargoCub,
  basedOnDens,
  basedOnTemp,
  asPer,
  totalAllowedDWT,
  lossOfDWT,
  availableDWT,
  availableMT,
  quantBillOfLaden,
  actualDeadweight,
  charterer,
}) => {
  const selectedTrip = getSelectedTrip(currentVoyage, selectedTripId);
  const selectedCargo = getSelectedCargo(
    currentVoyage,
    selectedTripId,
    selectedCargoIndex
  );

  if (!selectedTrip || !selectedCargo) {
    throw new Error("No trip or cargo data available.");
  }

  return {
    companyLogo: companyLogo || "",
    vesselName: currentVoyage?.vessel || "\u2014",
    title: "Deadweight Statement",
    portName: selectedTrip?.from || "\u2014",
    voyageNumber: getVoyageNumber(currentVoyage) || "\u2014",
    tripDate: selectedTrip?.date || "\u2014",
    charterer: charterer || "\u2014",
    cargoName: selectedCargo?.cargo || "\u2014",
    cargoQuantity: `${selectedCargo?.quantity || "\u2014"} ${selectedCargo?.unit || ""}`.trim(),
    zone: zone || "\u2014",
    governingDWT,
    bunkerConsumption,
    totalAllowedDWT,
    bunkers,
    freshwater,
    stores,
    ballast,
    slops,
    lossOfDWT,
    availableDWT,
    availableCBM,
    density,
    availableMT,
    maxQuantAccCP,
    claim,
    claimedDeadweight,
    requestedCargoMT,
    requestedCargoCub,
    basedOnDens,
    basedOnTemp,
    asPer,
    quantBillOfLaden,
    actualDeadweight,
  };
};
